export default "__VITE_ASSET__c2c79499__"